export const configuratorFunctions = [ 'finalizeproject', 'loadproject', 'createproject', 'caeimport', 'assistantimport' ] as const;

export type ConfiguratorFunction = typeof configuratorFunctions[number];
